<template>
  <a-modal
    title="物流节点详情"
    :visible="visible"
    class="status-modal"
    width="54%"
    :footer="null"
    @cancel="visible=false"
  >
    <a-timeline>
      <template>
        <a-timeline-item
          v-for="(item, index) in logList" 
          :key="index"
          :class="['item-cell', item.logTitle === STATUSENU.REJECTED && index === 0 ? 'item-reject' :index === 0 ? 'current-item' : '']"
          :color="item.logTitle === STATUSENU.REJECTED && index === 0 ? '#F56C6C' : index === 0 ? '#06B880' : '#CCCCCC'"
        >
          <img slot="dot" :src="getIcon(item.logTitle, index)"  />
          <div :class="['status-content', item.logTitle === STATUSENU.SIGNED ? 'signed-content' : '']">
            <p class="status-title">{{STATUS[item.logTitle || '']}}</p>
            <template v-if="item.subNodes && item.subNodes.length">
              <div v-if="item.subNodes.length > 1" class="transport-station">
                <p
                  v-for="(log, logIndex) in item.subNodes"
                  :key='`node${logIndex}`'
                  :class="active === logIndex ? 'active-station' : ''"
                  @click="active = Number(logIndex)"
                >
                  {{log.endStationName}}
                  <span v-if="log.status === STATUS.SIGNED" class="node-status">{{log.status}}</span>
                </p>
              </div>
              <template v-if="getSubNodes(item.subNodes, 'logDetails').length">
                <div
                  v-for="(details, detailIndex) in getSubNodes(item.subNodes, 'logDetails')"
                  :key="`detail${detailIndex}`"
                  :class="['describe', getSubNodes(item.subNodes, 'logDetails').length > 1 ? 'describe-more' : '']"
                >
                  <p>{{details.desc}}</p>
                  <p class="status-time">{{details.time | formatTimestamp}}</p>
                </div>
              </template>
              <template v-else>
                <div v-if="getSubNodes(item.subNodes, 'status') === STATUS.REJECTED" class="no-data">
                  <img :src="rejectPng" />
                  <p>您的订单已被拒收</p>
                </div>
                <div v-else-if="item.logTitle === STATUSENU.TRANSPORTING" class="no-data">
                  <img :src="noDataPng" />
                  <p>暂未派车，请派车后查询</p>
                </div>
              </template>
            </template>
          </div>
        </a-timeline-item>
      </template>
    </a-timeline>
  </a-modal>
</template>

<script>
import { ORDERSTATUS } from '../constant'
import { STATUSIMG, STATUS, STATUSENU } from './statusImg'
import { getLog, getWarehouseOrderLog, getWarehouseMultiOrderLog } from '../api'
import noDataPng from './imgs/no-data.png'
import rejectPng from './imgs/reject.png'

export default {
  name: 'StatusModal',
  data() {
    return {
      visible: false,
      ORDERSTATUS,
      STATUSIMG,
      STATUS,
      STATUSENU,
      odrNo: null,
      logList: [],
      noDataPng,
      rejectPng,
      active: 0,
      isWarehouse: false,
      isDischarge: false, // 仓配一装多卸
    }
  },
  computed: {
    getSubNodes() {
      return function(subNodes, type) {
        if (subNodes.length > 1) {
          return subNodes[this.active][type]
        } 
        return subNodes[0][type]
      }
    },
    getIcon() {
      return function(icon, index) {
        let img = STATUSIMG[icon]?.icon || ''
        if (index === 0) {
          img = STATUSIMG[icon]?.current || ''
        }
        return img
      }
    }
  },
  methods: {
    /**
     * orderNo 订单号
     * isWarehouse 是否是仓配订单
     * isDischarge 是否仓配一装多卸
     */
    show(orderNo, isWarehouse = false, isDischarge=false) {
      this.orderNo = orderNo;
      this.isWarehouse = isWarehouse
      this.active = 0
      this.isDischarge = isDischarge
      this.checkLogs();
    },
    async checkLogs() {
      let url = getLog
      if (this.isWarehouse) {
        if (this.isDischarge) {
          url =getWarehouseMultiOrderLog
        } else {
          url = getWarehouseOrderLog
        }
      }
      this.logList = await url({
        odrNo: this.orderNo,
      });
      this.visible = true;
    }
  }
}
</script>

<style lang="less" scoped>
.status-modal {
  ::v-deep {
    .ant-modal-body {
      height: auto;
      max-height: 545px;
      min-height: 233px;
      overflow-y: auto;
    }
    .ant-timeline {
      padding: 8px 0 0 8px;
      .ant-timeline-item-tail {
        display: inline-block;
        border-left: 1px solid #F0F2F5;
      }
    }
  }

  .item-cell {
    /deep/ .ant-timeline-item-head  {
      width: 24px;
      height: 24px;
      border: 2px solid #CCCCCC;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 16px;
        height: 16px;
      }
    }
    &.current-item {
      /deep/ .ant-timeline-item-head {
        background: #06B880;
      }
      .status-title {
        color: #06B880;
      }
    }
    &.item-reject {
      /deep/ .ant-timeline-item-head {
        background: #F56C6C;
      }
    }
    .status-content {
      margin-left: 8px;
      line-height: 18px;
      color: #606266;
      .no-data {
        color: #909399;
        font-size: 14px;
        margin-left: 23px;
        margin-top: 35px;
        width: 154px;
        text-align: center;
        img {
          width: 85px;
          height: 62px;
          margin-bottom: 13px;
        }
      }
      .transport-station {
        margin-bottom: 12px;
        p {
          padding: 5px 8px;
          display: inline-block;
          border-radius: 2px;
          margin-right: 4px;
          border: 1px solid #DCDEE0;
          color: #606266;
          cursor: pointer;
          margin-top: 8px;
          .node-status {
            background: #F4F5F6;
            border-radius: 9px;
            font-size: 12px;
            line-height: 18px;
            padding: 0 6px;
            margin-left: 5px;
            color: #909399;
          }
          &.active-station {
            background: #F4F5F6;
            border: 1px solid #DCDEE0;
            .node-status {
              border: 1px solid #DCDEE0;
            }
          }
          &:hover {
            border: 1px solid #C9CBCE;
            color: #06B880;
          }
        }
      }
      .describe {
        font-size: 12px;
      }
      .describe:first-of-type {
        margin-top: 12px;
      }
      .describe:not(:last-of-type) {
        margin-bottom: 24px;
      }
      .describe-more {
        position: relative;
        &::before {
          content: '';
          display: inline-block;
          position: absolute;
          width: 7px;
          height: 7px;
          background: #CCCCCC;
          border-radius: 50%;
          top: 6px;
          left: -25px;
        }
      }
      .status-title {
        font-size: 18px;
        font-weight: 500;
        line-height: 24px;
      }
      .status-time {
        color: #909399;
      }

      &.signed-content {
        color: #171717;
        .status-time {
          color: #171717;
        }
      }
    }
    &.current-item {
      .status-content {
        .transport-station {
          p {
            color: #171717;
            .node-status {
              color: #171717;
            }
            &.active-station {
              background: #E6F7F2;
              border: 1px solid #06B880;
              .node-status {
                border: none;
                background: #fff;
              }
            }
            &:hover {
              color: #06B880;
            }
          }
        }
      }
    }
  }
}
</style>
